export default {
  name: 'dashify:OrderedList',
  title: 'Ordered List',
  owner: 'System',
  solution: '',
  tags: ['html', 'list', 'ordered'],
  createdAt: 'May 30, 2023, 10:14 AM',
  updatedAt: 'May 31, 2023, 11:14 AM',
  spec: {
    view: [['div', { '.': 'border bg-lime-400' }, [['ul', { '.': 'p-2 grid gap-3' }, '/${ children }']]]],
  },
};
